import type { BDRequestType } from './apis/apiResponse.model';
import type { SeverityLevel } from './common.model';

export enum BDAppErrorType {
  API = 0,
  VALIDATION = 1,
}

export interface BDError<T = unknown> extends Error {
  status?: number;
  type?: BDAppErrorType;
  code?: string;
  messageKey?: string;
  requestId?: string;
  requestType?: BDRequestType;
  response?: T;
  severity?: SeverityLevel;
  data?: unknown;
}

// TODO: Add this type back when we rebuild errors
// export interface ApiError extends BDError {
//   errorCode: string;
//   errorType: BDAppErrorType.API;
//   message: string;
// }

export interface ValidationError<T = unknown> extends BDError<T> {
  errorCode: string;
  errorType: BDAppErrorType.VALIDATION;
  message: string;
  field: string;
}

// TODO: [rebrand-internal] internal error class name (BDError + "BrightDrop App Error" string) — consider renaming if a broader cleanup of internal BrightDrop references is planned (not customer-visible; class rename impacts ~all error-handling consumers)
export class BDError extends Error {
  constructor(message?: string, options?: Partial<BDError>) {
    super(message);
    this.name = 'BrightDrop App Error';
    if (options) {
      for (const o of Object.entries(options)) {
        const key = o[0] as keyof this;
        const value = o[1] as this[typeof key];
        this[key] = value;
      }
    }
  }

  // convert class-based error into object for use with redux state
  static asJson = <T>(error: BDError<T>): BDError<T> => {
    return { ...error, message: error.message };
  };
}
